import { Component, Vue, Prop } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import MiFileUpload from '@/components/mi-file-upload/MiFileUpload';
import { fileToBase64 } from '@/support/String';
import { addClass, removeClass } from '@/support/Html';
import { objectToFormdata } from '@/support/Client';
import { Product } from '@/models/Product';

@Component<UploadProductImageDialog>({
  components: {
    MiFileUpload,
  },
})
export default class UploadProductImageDialog extends Vue {
  @Prop({default: null})
  protected product!: Product;

  protected isLoading: boolean = false;
  protected activeStepper: boolean = true;
  protected currentStep: number = 1;

  protected acceptedFileTypes = [
    'image/png',
    'image/jpeg',
    'image/svg+xml',
  ];

  protected uploadedFiles: UploadedFile[] = [];
  protected selectedFile: UploadedFile = {};
  protected defaultFileIndex: number | null = null;
  protected isViewingThumbnail: boolean = false;

  protected mounted() {
    const pageHtml = document.querySelectorAll('html')[0];
    addClass(pageHtml, 'overflow-y-hidden');
  }

  protected goToStep(step: number) {
    if (this.currentStep < step || !this.activeStepper) {
      return;
    }

    this.currentStep = step;
  }

  protected handleItemDropped(file: File) {
    if(!file) {
      return;
    }

    fileToBase64(file).then((encodedFile: string) => {
      const uploadedFile: UploadedFile = {
        url: encodedFile,
        name: file.name,
        file: file,
      };
      this.uploadedFiles.push(uploadedFile);
    });

    const fileUploadComponent = this.$refs.fileUpload as MiFileUpload;
    fileUploadComponent.uploaded();
  }

  protected isViewingLargeThumbnail(uploadedFile: UploadedFile) {
    this.selectedFile = uploadedFile;
    this.isViewingThumbnail = true;
  }

  protected closeViewingThumbnailDialog() {
    this.isViewingThumbnail = false;
    this.selectedFile = {};
  }

  protected close() {
    this.$emit('input', false);
    this.currentStep = 1;
    this.clear();
    const pageHtml = document.querySelectorAll('html')[0];
    removeClass(pageHtml, 'overflow-y-hidden');
  }

  protected clear() {
    this.uploadedFiles = [];
    this.defaultFileIndex = null;
  }

  protected create() {
    let count = 0;
    this.isLoading = true;
    this.uploadedFiles.forEach((file: UploadedFile, index: number) => {
      let payload: {[key:string]: any} = {
        image: file.file,
      };

      if (this.defaultFileIndex !== null && this.defaultFileIndex === index) {
        payload = {...payload, ...{default: true}};
      }

      try {

        new Product()
          .attachImage(this.product.id)
          .create(objectToFormdata(payload))

        count += 1;
        this.currentStep = 3;
        if (count === this.uploadedFiles.length) {
          this.$emit('imagesUploaded');
          this.isLoading = false;
          return;
        };
      } catch (error) {
        ErrorHandler.network(error);
      }
    });
  }
}

interface UploadedFile {
  url?: string;
  name?: string;
  file?: any;
}
